import { darken } from 'polished';
import styled from 'styled-components';

import { generateFluidPxScale } from '../blog-2/utils';
import { gridColorSelector, GridRule } from '../v2/GridLines';
import { LayoutSubgrid } from '../v2/Page/LayoutGrid';
import { styles } from '../v2/UtilityCss/Text';

export const Section = styled(LayoutSubgrid)`
  position: relative;
  background-color: ${({ theme }) => darken(0.025, theme.palette.fg100)};
  border-top: 1px solid ${({ theme }) => gridColorSelector(theme, 'major')};

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background-image: ${({ theme }) => theme.textures.noise.img};
    background-size: ${({ theme }) => theme.textures.noise.size};
    mix-blend-mode: ${({ theme }) => theme.textures.noise.mixBlendMode};
    opacity: ${({ theme }) => theme.textures.noise.opacity};
    pointer-events: none;
  }
`;

export const CustomerStoriesGrid = styled(LayoutSubgrid)`
  display: grid;
  grid-template-columns: repeat(2, 1fr) !important;

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    grid-template-columns: 1fr !important;
  }
`;

export const CustomerStory = styled.div`
  grid-column: auto !important;
  display: flex;
  flex-direction: column;

  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    &:not(:last-child) {
      border-bottom: 1px solid
        ${({ theme }) => gridColorSelector(theme, 'major')};
    }
  }
`;

export const QuoteWrapper = styled.div`
  padding: 24px ${generateFluidPxScale(12, 32)} 40px
    ${generateFluidPxScale(12, 32)};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  place-content: center;
  flex-grow: 1;
`;

export const Quote = styled.q`
  text-align: center;
  max-width: 36rem;
  text-wrap: balance;
`;

export const Em = styled.em`
  font-weight: ${({ theme }) => theme.fontWeight.BOLD};
  color: ${({ theme }) => theme.palette.fgLoud};
`;

export const Attribution = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 32px;
`;

export const Author = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 16px;

  p {
    margin: 0;
    text-align: center;
  }

  p:first-child {
    color: ${({ theme }) => theme.palette.fgLoud};
  }
  p:last-child {
    font-size: ${({ theme }) => theme.fontSize.EXTRA_SMALL};
  }
`;

export const Logo = styled.img`
  margin: 0 auto 0 auto;
  height: 52px;
`;

export const StyledGridRule = styled(GridRule)`
  @media (max-width: ${({ theme }) => theme.mediaQuery.LARGE}) {
    display: none;
  }
`;

export function CustomerStories() {
  return (
    <Section>
      <LayoutSubgrid data-content-grid data-pile>
        <StyledGridRule $column={6} />
      </LayoutSubgrid>
      <CustomerStoriesGrid data-content-grid data-pile>
        <CustomerStory>
          <QuoteWrapper>
            <Logo src="https://images.ctfassets.net/mmgv7yhaaeds/7sRUSuKD5Sz769aM8P6Ulc/dab17dac7d206e01edbfd970e7d2d746/huckberry.svg" />
            <Quote className={styles.l}>
              “We generated <Em>over a million dollars in value</Em> from a
              leaner, more precise replenishment model.”
            </Quote>
            <Attribution>
              <Author>
                <Info>
                  <p className={styles.base}>Ben S.</p>
                  <p className={styles.annotation}>
                    Director Data & Analytics, Huckberry
                  </p>
                </Info>
              </Author>
            </Attribution>
          </QuoteWrapper>
        </CustomerStory>
        <CustomerStory>
          <QuoteWrapper>
            <Logo src="https://images.ctfassets.net/mmgv7yhaaeds/5vPww5FHfw0UynXyrSzZUR/211e3f4cd7cd2fd3621d8e87d237eba9/clickup-logo.svg" />
            <Quote className={styles.l}>
              “We needed a tool with{' '}
              <Em>
                the flexibility for anyone on any team to explore and build
              </Em>{' '}
              segments related to their part of the business. Hex unlocks that
              for ClickUp and has helped our teams save millions of dollars in
              churn.”
            </Quote>
            <Attribution>
              <Author>
                <Info>
                  <p className={styles.base}>Sai S.</p>
                  <p className={styles.annotation}>
                    Head of Growth Strategy & Ops at ClickUp
                  </p>
                </Info>
              </Author>
            </Attribution>
          </QuoteWrapper>
        </CustomerStory>
      </CustomerStoriesGrid>
    </Section>
  );
}
